import { FormModelInfoWithParameters } from "./types";

export const mapModelInfoToAPI = (
  modelInfo: FormModelInfoWithParameters,
  workspaceId: number,
) => {
  return {
    display_name: modelInfo.displayName,
    is_chat: modelInfo.modelType === "chat",
    is_internal: false,
    provider_id: modelInfo.provider_id,
    llm_model_name: modelInfo.modelName,
    params: modelInfo.parameters,
    workspace_id: workspaceId,
    id: modelInfo.id,
    provider_name: modelInfo.provider,
  };
};
